import getTheme from "./getTheme";
export default function speed(speed, theme) {
    return getTheme(theme).speed[speed];
}
//# sourceMappingURL=speed.js.map